.sticky {
  min-height: 60px !important;
  padding: 0 !important;
}

.sticky > div {
  margin: 0 !important;
}

.sticky.Mui-expanded {
  position: sticky;
  top: 45px;
  background: white;
  box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);
  z-index: 1;
}

.Closed:before,
.InProgress:before,
.Open:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-left: 10px solid;
  pointer-events: none;
}

.Closed:before {
  border-color: #367C2B;
}

.InProgress:before {
  border-color: #FFC107;
}

.Open:before {
  border-color: #f44336;
}

.cell {
  display: flex;
  align-items: center;
  flex: 1;
  padding: 15px 10px;
  padding-right: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell:first-child {
  padding-left: 30px;
}

.cell:last-child {
  padding-right: 30px;
}

.root .MuiExpansionPanelSummary-content {
  margin: 0 !important;
}
